import { useEffect, useState } from "react";
import { OrderAPI } from "../../providers/OrderAPI";
import styles from "../../styles/order-details.module.scss";

import { Button } from "../components/Button";
import { Icon } from "../components/core/Icon";
import { Loading } from "../components/Loading";
import { Message } from "../components/Message";

// import { convertMoney, getArrivedTime } from "../utils";

import ROLES from "data/Roles";
import { UserStorage } from "shared/tools/UserStorage";
import Customer from "./Customer";
import OrderItems from "./OrderItems";
import Payers from "./Payers";
import Totals from "./Totals";

const OrderStatus = {
  REJECTED: "REJECTED",
  CANCELED: "CANCELED",
  WAITING_PAYMENT: "WAITING_PAYMENT",
  OPENED: "OPENED",
  IN_PRODUCTION: "IN_PRODUCTION",
  ON_DELIVERY: "ON_DELIVERY",
  FINISHED: "FINISHED",
};

const NewOrder = ({
  orderId,
  playing,
  toggleSound,
  onAcceptOrder,
  onRejectOrder,
}) => {
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);
  const [statusWarning, setStatusWarning] = useState(false);

  let userRole = UserStorage.getLoggedUser()?.role;
  if (!userRole) userRole = ROLES.SHOPKEEPER;

  const canAccept = userRole !== ROLES.SHOPKEEPER;
  const canReject = true;

  const handleChangeStatus = (fn) => {
    setLoading(true);
    fn(order);
  };

  const getStatusWarning = (order) => {
    const orderStatuses = order.statuses || [];

    const orderStatus = orderStatuses.find(
      (orderStatus) =>
        ![OrderStatus.CANCELED, OrderStatus.REJECTED].includes(
          orderStatus.status
        ) && orderStatus?.value?.reason
    );

    return orderStatus?.value?.reason;
  };

  useEffect(() => {
    const loadOrder = async () => {
      const orderResponse = await OrderAPI.getOrderById(orderId);
      setOrder(orderResponse.getData({}));
      setStatusWarning(getStatusWarning(orderResponse.getData({})));
      setLoading(false);
    };

    loadOrder();
  }, [orderId]);

  return (
    <div className={styles.orderDetailsContainer}>
      {!loading && (
        <div className={styles.scrollContainer}>
          {statusWarning && (
            <Message
              type="warning"
              title={`Entregador não alocado`}
              text={statusWarning}
              className="mb-20"
            />
          )}
          <Customer order={order} />
          <OrderItems order={order} />
          <Payers order={order} />
          <Totals order={order} />
        </div>
      )}

      {loading && (
        <div className="d-flex justify-center align-center h-100">
          <Loading fullScreen />
        </div>
      )}

      <div className={styles.footer}>
        <Button
          design="default-icon"
          className="mr-15"
          onClick={toggleSound}
          disabled={loading}
        >
          <Icon name={!playing ? "volume" : "volume-mute"} size="xl" light />
        </Button>

        {canReject && (
          <Button
            design="default-icon"
            className="mr-15"
            onClick={() => handleChangeStatus(onRejectOrder)}
            disabled={loading}
          >
            <Icon name="times" size="xl" />
          </Button>
        )}

        {canAccept && (
          <Button
            design="primary"
            className="w-100"
            onClick={() => handleChangeStatus(onAcceptOrder)}
            disabled={loading}
          >
            Aceitar pedido
          </Button>
        )}
      </div>
    </div>
  );
};

export default NewOrder;
